// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xuSF-FnCLe3K12xRAikuL","title":"_3xEeu0lbjPStGYJAJ-c8-j","name":"_1oI_m_DuowMp0aA1-KeiG8","state":"_3gQjVV2hi_2Z4PdsEew2Oe"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/FromTemplate/styles.css
// module id = 2837
// module chunks = 0